import { formatCompactNumber, formatNumber } from "./format-number";

// Intl currency uses narrow no-break spaces; normalize for predictable display/tests.
const normalizeSpaces = (value: string): string => value.replace(/\s/g, " ");

const exactFormatters = new Map<string, Intl.NumberFormat>();
const compactFormatters = new Map<string, Intl.NumberFormat>();

const getFormatter = (
  cache: Map<string, Intl.NumberFormat>,
  currency: string,
  compact: boolean,
): Intl.NumberFormat | null => {
  const cached = cache.get(currency);
  if (cached) {
    return cached;
  }
  try {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: compact ? 1 : 0,
      ...(compact ? { notation: "compact" as const } : {}),
    });
    cache.set(currency, formatter);
    return formatter;
  } catch {
    // Unknown / invalid ISO currency code: fall back to a plain number.
    return null;
  }
};

/** Native currency only; never converts between currencies. */
export const formatCurrency = (value: number, currency: string): string => {
  const formatter = getFormatter(exactFormatters, currency, false);
  return formatter
    ? normalizeSpaces(formatter.format(value))
    : formatNumber(value);
};

export const formatCurrencyCompact = (
  value: number,
  currency: string,
): string => {
  const formatter = getFormatter(compactFormatters, currency, true);
  return formatter
    ? normalizeSpaces(formatter.format(value))
    : formatCompactNumber(value);
};
